// extracted by mini-css-extract-plugin
module.exports = {"qrQrapper":"QrCodeScannerDialog_qrQrapper__1zTB-"};